import { useMemo } from 'react';
import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { LoanConsultantsDocument } from 'graphql/generated/graphql';

const useGetLoanConsultants = () => {
  const { data, loading } = useQuery(LoanConsultantsDocument);
  const loanConsultants = useMemo(() => get(data, 'loanConsultants', []), [data]);
  return [loanConsultants, loading] satisfies [typeof loanConsultants, boolean];
};

export default useGetLoanConsultants;
